import { AdminLayout } from "../../../components";
import { RefListSection } from "../../../section";

export const RefListPage = () => {
  return (
    <AdminLayout>
      <RefListSection />
    </AdminLayout>
  );
};
